@if (open && showBackdrop) {
  <div class="side-drawer-backdrop" [style.zIndex]="zIndex" (click)="close()"
  (keydown.escape)="close()"></div>
}

<aside class="side-drawer" [class.open]="open" [class.keyboard-tab-mode]="keyboardTabMode" [style.width.px]="width" [style.maxWidth]="maxWidth"
  [style.--app-drawer-top-offset.px]="drawerTop" [style.--app-drawer-height.px]="drawerHeight"
  [style.zIndex]="zIndex + 1" #drawerPanel aria-label="Status page side drawer"
  [attr.aria-hidden]="open ? 'false' : 'true'" tabindex="-1"
  cdkTrapFocus [cdkTrapFocus]="open">
  <div class="side-drawer-body">
    <ng-content></ng-content>
  </div>
</aside>
